/**
 * Removes units from a string and returns the numeric value.
 *
 * @example
 *   removeUnits('-10px')   // -10
 *   removeUnits('10.5rem') // 10.5
 *   removeUnits('-10')     // -10
 *   removeUnits('22.5%')   // 22.5
 *   removeUnits('abc')     // null
 *
 * @param {string} value The string containing the numeric value with units.
 * @returns {number|null} The numeric value without units, or null if no numeric value is found.
 */
export function removeUnits(value) {
  const number = value.match(/[\d.]+/)
  return number ? parseFloat(number[0]) : null
}
